import type { ConfluenceSidebarState } from '../content-types-shell-types.ts';

export type ChangeObjectSidebarControlShownHandler = (state: ConfluenceSidebarState) => void;
export type ChangeObjectSidebarControlShownHandler_LEGACY = (isShown: boolean) => void;

export class ContentTypesObjectSidebarService {
	private changeObjectSidebarShownHandler: ChangeObjectSidebarControlShownHandler[];
	private changeObjectSidebarShownHandler_LEGACY: ChangeObjectSidebarControlShownHandler_LEGACY[];

	constructor() {
		this.changeObjectSidebarShownHandler = [];
		this.changeObjectSidebarShownHandler_LEGACY = [];
	}

	dispose(): void {
		this.changeObjectSidebarShownHandler = [];
		this.changeObjectSidebarShownHandler_LEGACY = [];
	}

	registerChangeObjectSidebarShownHandler(callback: (state: ConfluenceSidebarState) => void): void {
		this.changeObjectSidebarShownHandler.push(callback);
	}

	registerChangeObjectSidebarShownHandler_LEGACY(callback: (isShown: boolean) => void): void {
		this.changeObjectSidebarShownHandler_LEGACY.push(callback);
	}

	onChangeObjectSidebarShown(state: ConfluenceSidebarState): void {
		this.changeObjectSidebarShownHandler.forEach((callback) => callback(state));
	}

	onChangeObjectSidebarShown_LEGACY(isShown: boolean): void {
		this.changeObjectSidebarShownHandler_LEGACY.forEach((callback) => callback(isShown));
	}
}
